module.exports = __webpack_public_path__ + "static/img/3.7762b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/3.png
// module id = hm+o
// module chunks = 1